export default {
  props: {
    zIndex: {
      type: Number,
      default: 100
    },
    maskClosable: {
      type: Boolean,
      default: false
    }
  }
}



// WEBPACK FOOTER //
// ./node_modules/cube-ui/src/common/mixins/popup.js